import { isHiddenFromDiscoveryListing } from './listingHelpers';
import { serviceBinding } from './sharedBookingRuntime';

const listingId = listing => listing?.id?.uuid;
const validPrice = price =>
  price &&
  Number.isSafeInteger(price.amount) &&
  price.amount >= 0 &&
  typeof price.currency === 'string';

const mappedPrice = (service, inventory) => {
  const resolved = serviceBinding(service);
  if (resolved.status !== 'active') return null;

  const master = inventory.find(listing => listingId(listing) === resolved.binding.masterListingId);
  const variants = master?.attributes?.publicData?.priceVariants || [];
  const variant = variants.find(v => v.name === resolved.binding.masterPriceVariantName);
  const currency = master?.attributes?.price?.currency;
  return Number.isSafeInteger(variant?.priceInSubunits) && variant.priceInSubunits >= 0 && currency
    ? { amount: variant.priceInSubunits, currency }
    : null;
};

// Search filters supply `services`; full inventory is used only to resolve the authoritative master variant.
export const getPractitionerFromPrice = (services = [], inventory = [], currency) => {
  const prices = services
    .filter(service => !isHiddenFromDiscoveryListing(service))
    .map(service => mappedPrice(service, inventory) || service?.attributes?.price)
    .filter(validPrice)
    .filter(price => !currency || price.currency === currency);

  return prices.reduce(
    (lowest, price) => (!lowest || price.amount < lowest.amount ? price : lowest),
    null
  );
};
